module.exports = __webpack_public_path__ + "static/UnclickOthersYellow-74875ff33e1f46a6d7cf8bbb770afdfd.png";